import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  fetch as fetchMap,
  toggleMapView,
} from 'actions/map';
import { openSidebar } from 'actions/sidebar';

import Config from 'configuration';
import ResponsiveMenuComponent from './ResponsiveMenuComponent';

class ResponsiveMenuContainer extends React.Component {
  mapIsEnabled = () => {
    const { canTravel, phase, location: { pathname } } = this.props;
    return canTravel && phase === 'Available' && pathname === '/';
  };

  openSidebar = () => {
    const { dispatch } = this.props;
    return dispatch(openSidebar());
  };

  /**
   * Toggle map
   * @return {undefined}
   */
  toggleMap = () => {
    const { dispatch, shouldMapUpdate } = this.props;
    if (!this.mapIsEnabled()) {
      return;
    }
    if (shouldMapUpdate) {
      dispatch(fetchMap());
    }
    dispatch(toggleMapView());
  };

  render = () => {
    const { currentArea } = this.props;
    const mapTitle = setMapTitle(this.props);
    const bgImage = `${Config.imageUrl}headers_small/${currentArea.image}.png`;

    return (
      <ResponsiveMenuComponent
        bgImage={bgImage}
        mapIsEnabled={this.mapIsEnabled()}
        mapTitle={mapTitle}
        onOpenMap={this.toggleMap}
        onOpenSidebar={this.openSidebar}
      />
    );
  }
}

ResponsiveMenuContainer.displayName = 'ResponsiveMenuContainer';

ResponsiveMenuContainer.propTypes = {
  canTravel: PropTypes.bool.isRequired,
  currentArea: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  shouldMapUpdate: PropTypes.bool.isRequired,
  phase: PropTypes.string.isRequired,
};

function setMapTitle({ canTravel, phase }) {
  if ((canTravel && phase === 'Available')) {
    return 'Map';
  }

  return 'Map - you cannot move right now';
}


const mapStateToProps = ({
  storylet: { phase },
  map,
  map: {
    shouldUpdate: shouldMapUpdate,
    currentArea,
    canTravel,
  },
}) => ({
  map, shouldMapUpdate, currentArea, canTravel, phase,
});

export default withRouter(connect(mapStateToProps)(ResponsiveMenuContainer));
